function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKelpLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 980 980",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,290.579,-55.3226)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.69601,-63.8513,-323.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.851,683.443L208.851,683.443C208.851,683.443 203.018,719.068 213.851,726.193C224.685,733.319 263.018,733.319 273.851,726.193C284.685,719.068 278.851,683.443 278.851,683.443Z",
    style: {
      fill: "rgb(221,221,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8483,0,0,4.99426,-351.051,-2405.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.185,514.569C213.603,502.821 191.697,492.793 184.956,492.673C176.927,492.53 155.081,506.102 151.509,514.569C147.936,523.037 166.657,532.779 166.657,555.266C166.657,571.119 142.631,590.045 142.631,608.641C142.631,629.575 145.361,633.079 150.466,640.417C154.061,645.586 163.155,651.035 170.933,652.75C179.725,654.689 194.758,654.056 203.219,652.05C210.25,650.384 219.767,647.801 221.698,640.719C224.803,629.33 219.76,629.283 219.76,608.641C219.76,587.999 243.896,572.708 243.896,555.266C243.896,533.558 233.679,523.186 225.185,514.569Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.137,55.385C130.081,57.692 70.435,123.358 60.492,164.684C50.317,206.974 103.638,255.629 103.638,367.931C103.638,447.105 35.205,541.629 35.205,634.502C35.205,739.054 42.981,756.552 57.522,793.202C67.763,819.014 93.663,846.23 115.818,854.796C126.351,858.869 140.028,860.669 154.137,860.642L154.137,55.385Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-55.2049,62.4215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.69601,-63.8513,-323.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.851,683.443L208.851,683.443C208.851,683.443 203.018,719.068 213.851,726.193C224.685,733.319 263.018,733.319 273.851,726.193C284.685,719.068 278.851,683.443 278.851,683.443Z",
    style: {
      fill: "rgb(221,221,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8483,0,0,4.99426,-351.051,-2405.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.185,514.569C213.603,502.821 191.697,492.793 184.956,492.673C176.927,492.53 155.081,506.102 151.509,514.569C147.936,523.037 166.657,532.779 166.657,555.266C166.657,571.119 142.631,590.045 142.631,608.641C142.631,629.575 145.361,633.079 150.466,640.417C154.061,645.586 163.155,651.035 170.933,652.75C179.725,654.689 194.758,654.056 203.219,652.05C210.25,650.384 219.767,647.801 221.698,640.719C224.803,629.33 219.76,629.283 219.76,608.641C219.76,587.999 243.896,572.708 243.896,555.266C243.896,533.558 233.679,523.186 225.185,514.569Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.137,55.385C130.081,57.692 70.435,123.358 60.492,164.684C50.317,206.974 103.638,255.629 103.638,367.931C103.638,447.105 35.205,541.629 35.205,634.502C35.205,739.054 42.981,756.552 57.522,793.202C67.763,819.014 93.663,846.23 115.818,854.796C126.351,858.869 140.028,860.669 154.137,860.642L154.137,55.385Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,636.362,62.4215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.69601,-63.8513,-323.117)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.851,683.443L208.851,683.443C208.851,683.443 203.018,719.068 213.851,726.193C224.685,733.319 263.018,733.319 273.851,726.193C284.685,719.068 278.851,683.443 278.851,683.443Z",
    style: {
      fill: "rgb(221,221,221)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.8483,0,0,4.99426,-351.051,-2405.21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.185,514.569C213.603,502.821 191.697,492.793 184.956,492.673C176.927,492.53 155.081,506.102 151.509,514.569C147.936,523.037 166.657,532.779 166.657,555.266C166.657,571.119 142.631,590.045 142.631,608.641C142.631,629.575 145.361,633.079 150.466,640.417C154.061,645.586 163.155,651.035 170.933,652.75C179.725,654.689 194.758,654.056 203.219,652.05C210.25,650.384 219.767,647.801 221.698,640.719C224.803,629.33 219.76,629.283 219.76,608.641C219.76,587.999 243.896,572.708 243.896,555.266C243.896,533.558 233.679,523.186 225.185,514.569Z",
    style: {
      fill: "rgb(34,181,115)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,20,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.137,55.385C130.081,57.692 70.435,123.358 60.492,164.684C50.317,206.974 103.638,255.629 103.638,367.931C103.638,447.105 35.205,541.629 35.205,634.502C35.205,739.054 42.981,756.552 57.522,793.202C67.763,819.014 93.663,846.23 115.818,854.796C126.351,858.869 140.028,860.669 154.137,860.642L154.137,55.385Z",
    style: {
      fill: "rgb(78,196,143)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKelpLight);
export default __webpack_public_path__ + "static/media/kelp-light.f562a01e05a34050105f100daae04e19.svg";
export { ForwardRef as ReactComponent };